import { useEffect } from 'react';

let lockCount = 0;
let previousStyles = null;

function getScrollbarWidth() {
  if (typeof window === 'undefined') return 0;
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

function lockBodyScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  lockCount += 1;
  if (lockCount > 1) return;

  const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
  const scrollbarWidth = getScrollbarWidth();

  previousStyles = {
    scrollY,
    bodyOverflow: document.body.style.overflow,
    bodyPosition: document.body.style.position,
    bodyTop: document.body.style.top,
    bodyWidth: document.body.style.width,
    bodyPaddingRight: document.body.style.paddingRight,
    htmlOverflow: document.documentElement.style.overflow,
  };

  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function unlockBodyScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (lockCount <= 0) return;
  lockCount -= 1;
  if (lockCount > 0 || !previousStyles) return;

  const restore = previousStyles;
  previousStyles = null;

  document.documentElement.style.overflow = restore.htmlOverflow;
  document.body.style.overflow = restore.bodyOverflow;
  document.body.style.position = restore.bodyPosition;
  document.body.style.top = restore.bodyTop;
  document.body.style.width = restore.bodyWidth;
  document.body.style.paddingRight = restore.bodyPaddingRight;
  window.scrollTo(0, restore.scrollY);
}

export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;
    lockBodyScroll();
    return unlockBodyScroll;
  }, [locked]);
}

export default useBodyScrollLock;
